import { render, staticRenderFns } from "./verifyRegister.vue?vue&type=template&id=49cbfd16"
import script from "./verifyRegister.vue?vue&type=script&lang=js"
export * from "./verifyRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports